// Flags turned on together by the "Enable sync flags" button.
export const SYNC_FEATURE_FLAGS = [
  'LEAD_PRODUCER_SYNC',
  'TASK_PRODUCER_SYNC',
  'APPOINTMENT_PRODUCER_SYNC',
  'AGENT_PRODUCER_SYNC',
  'NOTE_PRODUCER_SYNC',
  'COMM_PRODUCER_SYNC',
  'PROPERTY_VIEW_NOTE_DELTA_PROCESSING',
  'LEAD_PRUNING_SYNC',
  'TASK_PRUNING_SYNC',
  'APPOINTMENT_PRUNING_SYNC',
  'AGENT_PRUNING_SYNC',
  'NOTE_PRUNING_SYNC',
];

export type FeatureDisplay = {
  label: string;
  tooltip: string;
  badge?: 'Alpha';
};

// Keys present here render in the curated section in this order.
// Flags not in this map fall into the "experimental" section behind a toggle.
export const FEATURE_DISPLAY: Record<string, FeatureDisplay> = {
  CONFIRM_APPOINTMENT_CREATION: {
    label: 'Confirm Appointment Creation',
    tooltip:
      'When enabled, requires confirmation before creating appointments from calls',
  },
  DISPOSITION_CALL: {
    label: 'Call for Disposition',
    tooltip: 'Enable call disposition functionality for tracking call outcomes',
  },
  CALENDAR_DISPOSITION: {
    label: 'Calendar Disposition',
    tooltip: 'Enable calendar-based disposition for FUB clients',
  },
  AGENT_LEVEL_DAILY_SYNC: {
    label: 'Agent Level Daily Sync',
    tooltip: 'Enable daily synchronization for agent-level data',
  },
  PROACTIVE_CALL: {
    label: 'Proactive Call',
    tooltip: 'Enable proactive calling workflows',
  },
  PROACTIVE_SMS: {
    label: 'Proactive SMS',
    tooltip:
      'Enable proactive SMS reminders to agents based on task keywords (text, remind, etc.)',
  },
  ALWAYS_USE_DIALER: {
    label: 'Always Use Dialer',
    tooltip: 'Enable always use dialer for calls',
  },
  VOICE_AI_3_0: {
    label: 'Voice 3.0',
    tooltip: 'Enable Voice AI 3.0 for enhanced voice interactions',
  },
  NEW_ONBOARDING_FLOW: {
    label: 'Enable new onboarding flow',
    tooltip: 'Enable new onboarding flow',
  },
  AGENT_PLAYBOOK: {
    label: 'Agent Playbook',
    tooltip: 'Enable agent playbook functionality',
  },
  CREATE_LEAD: {
    label: 'Create Lead',
    tooltip: 'Enable lead creation via chat/voice',
  },
  SOURCE_DISCOVERY_AUDIT: {
    label: 'Source Discovery Audit',
    tooltip:
      'Enable source reporting for this client. Note: it takes about an hour for reports to start showing up.',
  },
};

export function humanizeFeatureName(name: string): string {
  const lower = name.toLowerCase().replace(/_/g, ' ');
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
